/**
 *
 * Wrap any component to disable it!
 *
 */
import { Box, styled } from '@mui/material';
export const Disabler = styled(Box)(({ disabled }) => ({
    opacity: disabled ? 0.3 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
    transition: 'opacity 0.3s',
}));
export default Disabler;
